import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { darken } from 'polished';
import bindMethods from 'auto-bind';

import { LIGHT_GREY, RED, WHITE } from '../constants/colors';
import { login } from '../state/auth';
import { setAuthInLocalStorage } from '../utils/localStorage';

const AccountLoginContainer = styled.div`
  padding: 50px;
  width: 425px;
`;

const AccountLoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FormHeadline = styled.h1`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 15px;
`;

const InputField = styled.input`
  width: 325px;
  height: 35px;
  border-radius: 2px;
  border: 1px solid ${darken(0.05, LIGHT_GREY)};
  margin-bottom: 15px;
  padding: 6px 12px;
  font-size: 16px;
`;

const SubmitButton = styled.button`
  height: 35px;
  border: none;
  background: ${RED};
  color: ${WHITE};
  border-radius: 2px;
  font-size: 16px;
  cursor: pointer;

  :hover {
    background: ${darken(0.05, RED)};
  }

  :disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }
`;

class AccountLogin extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.state = {
      isSubmitting: false,
      email: '',
      password: '',
    };
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.updateStateValue(name, value);
  }

  handleFormSubmit(event) {
    event.preventDefault();

    this.setState({ isSubmitting: true }, async () => {
      try {
        const { email, password } = this.state;
        const { history, login: loginUser } = this.props;

        const authResponse = await loginUser(email, password);
        setAuthInLocalStorage(authResponse);
        history.push('/');
      } catch (error) {
        this.setState({ isSubmitting: false });
      }
    });
  }

  updateStateValue(name, value) {
    this.setState({ [name]: value });
  }

  render() {
    const { t } = this.props;
    const { isSubmitting } = this.state;

    return (
      <AccountLoginContainer>
        <FormHeadline id="Login.Heading">{t('AccountLogin.FormHeadline')}</FormHeadline>

        <AccountLoginForm onSubmit={this.handleFormSubmit}>
          <InputField
            id="Login.Email"
            name="email"
            type="email"
            placeholder={t('AccountLogin.Form.Placeholders.Email')}
            onChange={this.handleInputChange}
          />

          <InputField
            id="Login.Password"
            name="password"
            type="password"
            placeholder={t('AccountLogin.Form.Placeholders.Password')}
            onChange={this.handleInputChange}
          />

          <SubmitButton id="Login.Submit" disabled={isSubmitting}>
            {t('AccountLogin.SubmitButton')}
          </SubmitButton>
        </AccountLoginForm>
      </AccountLoginContainer>
    );
  }
}

AccountLogin.propTypes = {
  history: PropTypes.object.isRequired, // supplied from withRouter
  login: PropTypes.func.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

const ConnectedRouterComponenet = withRouter(AccountLogin);
const TranslatedComponent = withTranslation()(ConnectedRouterComponenet);

const mapDispatchToProps = { login };

export default connect(
  null,
  mapDispatchToProps,
)(TranslatedComponent);
